import { Text } from 'app/design/primitives/text';
import { Trans } from 'react-i18next';
import { useScopedTranslation } from 'app/hooks/i18n';

export function InviteDetails2({
  numInvited,
  tPrefix,
  tSuffix,
}: {
  numInvited: number;
  tPrefix: string;
  tSuffix: string;
}) {
  const { t } = useScopedTranslation();
  if (t(`${tPrefix}details2${tSuffix}`) === '') return null;
  return (
    <Text fontSize={20} lineHeight={26} marginHorizontal="spacing.general.x4">
      <Trans
        components={{ strong: <Text fontWeight="700" /> }}
        i18nKey={`${tPrefix}details2${tSuffix}`}
        ns="invite"
        values={{ numInvited }}
      />
    </Text>
  );
}
